const color = {
  primary: "#231F20",
  secondary: "#333333",
  green: "#187E3F",
  lightGreen: "#37B35A",
  darkGrey: "#4a4a4a",
  burgundy: "#6B1B10"
  // tertiary: "#28793B",
  // grey: "#D8D8D8",
  // lightgrey: "#F3F3F3",
  // darkgreen: "#187E3E",
  // lightgreen: "#37B459",
  // cream: "#F8F6EA",
  // darkTan: "#6B1B10",
}

export default color
